import type { StepRenderProps } from "./types";
import type { TextStep as TextStepConfig } from "@/types/offer";

export function TextStep({ step, value, onChange, autoFocus, error }: StepRenderProps<TextStepConfig>) {
  return (
    <input
      type="text"
      className="r1-field"
      autoFocus={autoFocus}
      placeholder={step.placeholder}
      value={typeof value === "string" ? value : ""}
      onChange={(e) => onChange(e.target.value)}
      aria-invalid={!!error}
      aria-label={step.title}
    />
  );
}
